module.exports = __webpack_public_path__ + "img/bandwidth2x.png?ea73e04c4a23e73edfa811cabd985ac6";